window.Products.Clothing.CheekyBriefs = function() {
};
window.Products.Clothing.CheekyBriefs.inherits(window.Products.Clothing.Clothing);

window.Products.Clothing.CheekyBriefs.id = 78;
window.Products.Clothing.CheekyBriefs.slug = 'cheeky-briefs';
window.Products.Clothing.CheekyBriefs.has_3d = true;
window.Products.Clothing.CheekyBriefs.dpi = 150;
window.Products.Clothing.CheekyBriefs.use_glb = true;

window.Products.Clothing.CheekyBriefs.prototype.set3dProperties = function(modelViewer) {
	// Peachskin in, Elastic, Elastic in, Peachskin
	this.updateThreeTexture(modelViewer);
	modelViewer.object.position.y = -4.3;
	modelViewer.camera.position.z =  1.7;
	modelViewer.initalCameraPosition.z = -1.7;

	modelViewer.object.children[0].children[0].material.transparent = true;
	modelViewer.object.children[0].children[0].material.opacity = 0.5;
	modelViewer.object.children[0].children[3].material.side = THREE.DoubleSide;
};

window.Products.Clothing.CheekyBriefs.prototype.setThreeControls = function(controls) {
	controls.minDistance = 5;
	controls.maxDistance = 8;
};

window.Products.Clothing.CheekyBriefs.prototype.updateThreeTexture = function(modelViewer) {
	modelViewer.texture.flipY = false;
	modelViewer.object.children[0].children[1].material.map = modelViewer.texture;
	modelViewer.object.children[0].children[3].material.map = modelViewer.texture;
};